import { PersonCard } from "../../components/activities/PersonCard";
import type { PersonCardGridComponent } from "../../types";
import { resolveLinkHref } from "../../utils/links";

/** Person card grid renderer (photo, name, role). */
export function PersonCardGridRenderer({ component }: { component: PersonCardGridComponent }) {
  const { items } = component.content;
  return (
    <section className="grid items-stretch pt-4 gap-4 sm:gap-6 md:grid-cols-3">
      {items.map((a, idx) => (
        <PersonCard
          key={`${resolveLinkHref(a.href) || a.title || "person"}-${idx}`}
          title={a.title}
          description={a.description ?? ""}
          href={a.href}
          imageSrc={(a as any).imageSrc}
          imageAlt={(a as any).imageAlt}
        />
      ))}
    </section>
  );
}
